import React from 'react';
import type { FC, PropsWithChildren } from 'react';

type InputsSectionProps = PropsWithChildren<{
  style?: React.CSSProperties;
  customClass?:string
}>;

const InputsSection: FC<InputsSectionProps> = props => {
  return (
    <div className={`modalContainer__form--section ${props.customClass || ''}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default InputsSection;
